














import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { IconArrowRight } from '@/icons';

@Component({
  components: {
    IconArrowRight,
  },
})
export default class BlockVideoPlayer extends Vue {
  // TODO: add bg type
  @Prop(String)
  backgroundColor!: string

  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: Number, required: true })
  videoLength!: number

  @Prop(String)
  vimeoId!: string

  @Prop(String)
  youtubeId!: string
}
